import { Checkbox } from "construct-ui";
import paginationComponent from "../../components/pagination/pagination.component";
import SelectUserComponent from "../../components/user/select-user.component";
import { downloadSEAOUserMovementWarehouseMapExcel, getSEAOUserMovementWarehouseMap, updateSEAOUserMovementWarehouseMap } from "../../models/retail-asset-management/seao-posm-authorization.model";
import ViewBase from "../view-base.view";

export default function SEAOPOSMUserMovementWarehouseMappingView() {
  ViewBase.call(this)

  const DESCENDING_TEXT = 'DESC';
  const ASCENDING_TEXT = 'ASC';

  const DEFAULT_PAGINATION = {
    pageIndex: 1,
    pageSize: 10,
    totalItems: 0,
  };

  const STATIC_COLUMNS = [
    { code: 'userId', name: 'User ID', labelCode: '' },
    { code: 'userName', name: 'User Name', labelCode: '' },
    { code: 'movementType', name: 'Movement Type', labelCode: '' },
    { code: 'movementTypeName', name: 'Movement Type Name', labelCode: '' },
  ];

  const STATIC_KEYS = ['userid', 'username', 'movementtypecode', 'movementtypename', 'rownum'];

  let warehouseList = [];
  let selectedMapping = null;
  let selectedOrderBy = '';
  let selectedSortBy = '';
  let pagination = structuredClone(DEFAULT_PAGINATION);
  let selectedUsers = [];
  let currentUsers = null;
  let tableData = [];
  let tableDataHasChanged = false;

  const _onSearchBtnClick = (e) => {
    e.preventDefault();
    pagination = structuredClone(DEFAULT_PAGINATION);
    currentUsers = structuredClone(selectedUsers);
    selectedOrderBy = '';
    selectedSortBy = '';
    searchUserMovementWarehouseMap();
  }

  const searchUserMovementWarehouseMap = () => {
    this.showLoading();
    tableData = [];
    warehouseList = [];

    let params = {
      movementType: 'GR',
      userIds: currentUsers?.map((user) => user.userID).join('^') || '',
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      sortBy: selectedSortBy,
      orderBy: selectedOrderBy,
    }

    getSEAOUserMovementWarehouseMap(params)
      .then((result) => {
        if (result != null) {
          tableData = result.data;
          pagination.totalItems = result.total;
          if (result.data.length) {
            Object.keys(result.data[0]).forEach((key) => {
              if (!STATIC_KEYS.includes(key.toLocaleLowerCase())) {
                let splitted = key.split(':');
                warehouseList.push({ name: splitted[0], id: splitted[1] });
              }
            });
          }


        }
      })
      .catch((error) => { this.handleError(error) })
      .finally(() => { this.hideLoading() });
  }

  const _updateUserWarehouseMap = () => {
    this.showLoading();
    let listWarehouseIds = Object.keys(selectedMapping)
      .filter((key) => selectedMapping[key] == 1 && !STATIC_KEYS.includes(key.toLocaleLowerCase()))
      .map((key) => key.split(':')[1])
      .join('^');

    let params = {
      userID: selectedMapping['UserId'],
      movementType: selectedMapping['MovementTypeCode'],
      warehouseIDs: listWarehouseIds,
    }

    updateSEAOUserMovementWarehouseMap(params)
      .then((result) => {
        if (result) {
          this.showMessage(
            this.getText("EM00000762", "Changes have been saved."),
            this.getText("EM0000004", "Success"));
        } else {
          this.showMessage(
            this.getText("EM00000138", "Server error. Please contact administrator."),
            this.getText("EM00000036", "Fail"));
        }
      })
      .catch((error) => { this.handleError(error) })
      .finally(() => {
        selectedMapping = null;
        tableDataHasChanged = false;
        searchUserMovementWarehouseMap();
      })
  }

  const renderUpdateField = () => {
    const rowQty = Math.ceil(warehouseList.length / 4)
    let res = [];
    for (let i = 0; i < rowQty; i++) {
      for (let j = 0; j < 4; j++) {
        let item = warehouseList[j * rowQty + i]
        if (item) {
          res.push(
            m('.col-md-3.position-relative.g-1',
              m(Checkbox,
                {
                  id: item.id,
                  checked: selectedMapping[`${item.name}:${item.id}`] == 1,
                  onchange: (e) => {
                    tableDataHasChanged = true;
                    selectedMapping[`${item.name}:${item.id}`] = e.target.checked;
                  }
                }),
              m('label.form-label', { for: item.id, style: { overflowWrap: "anywhere" } }, item.name)
            ),
          )
        } else res.push(m('.col-md-3'))
      }

    }
    return res
  }

  const _onExcelDownload = () => {
    this.showLoading();
    downloadSEAOUserMovementWarehouseMapExcel({
      movementType: 'GR',
      users: currentUsers?.map((user) => user.userID).join('^') || '',
    })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const _leavePageEventListener = () => {
    if (tableDataHasChanged && !confirm(this.getText('EM00000776', 'Changes you made may not be saved'))) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }
  const _flipOrderText = (orderText) => {
    return orderText.toUpperCase() === DESCENDING_TEXT ? ASCENDING_TEXT : DESCENDING_TEXT
  }

  const _getSortIcon = (orderBy) => {
    if (selectedSortBy !== orderBy) {
      return null
    }
    return selectedOrderBy === DESCENDING_TEXT ? m('i.bi.bi-sort-down') : m('i.bi.bi-sort-up')
  }

  const _onSortClick = (orderBy) => {
    if (selectedSortBy === orderBy) {
      selectedOrderBy = _flipOrderText(selectedOrderBy)
    } else {
      selectedSortBy = orderBy;
      selectedOrderBy = DESCENDING_TEXT;
    }
    searchUserMovementWarehouseMap();
  }

  const _onPageChanged = (page) => {
    pagination.pageIndex = page;
    searchUserMovementWarehouseMap();
  }

  const _onPageSizeChanged = (page, size) => {
    pagination.pageIndex = page;
    pagination.pageSize = size;
    searchUserMovementWarehouseMap();
  }

  return {
    oninit: () => {
    },
    oncreate: () => {
      addEventListener('route', _leavePageEventListener);
      addEventListener('beforeunload', _leavePageEventListener);
    },
    onremove: () => {
      removeEventListener('route', _leavePageEventListener);
      removeEventListener('beforeunload', _leavePageEventListener);
    },
    view: () => {
      return [
        // SEARCH
        m(".card.mb-3",
          m(".card-body",
            m('form.needs-validation[novalidate].row.g-2',
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="userNameSelect"]', this.getText('LT00000009', 'User')),
                m('.input-group',
                  m(SelectUserComponent, {
                    default: {
                      userStatusCode: '0001'
                    },
                    onSelect: (s) => {
                      selectedUsers = s;
                    },
                    selectedUserList: selectedUsers,
                  })
                )
              ),
              m('.col-12.d-flex.justify-content-end.gap-2',
                m('button.btn.btn-primary[type="submit"]', {
                  onclick: _onSearchBtnClick
                }, this.getText("LT00000001", "Search")),
              ),

            )
          )
        ),
        // SEARCH - end

        // Table section
        m('.card.mb-3',
          m('.card-body',
            m('.row.g-2',
              m('.col-12',
                m('.d-flex.justify-content-end.mb-2',
                  m('button.btn.btn-primary',
                    {
                      onclick: _onExcelDownload,
                      disabled: tableData.length == 0
                    },
                    m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                  )
                )
              ),
              m('.col-12.p-0',
                m('.table-responsive.table-fixed-header',
                  m('table.table.table-hover.table-bordered', [
                    m('thead.thead-bggrey.posm-user-wm-sticky-header',
                      m('tr.align-middle',
                        STATIC_COLUMNS.map(({ name, code }) =>
                          (code !== 'movementTypeName') &&
                          m('th.posm-user-wm-sticky-column[scope="col"]',
                            {
                              // style: { position: "fixed" },
                              rowspan: 2,
                              onclick: () => { _onSortClick(code) },
                            },
                            _getSortIcon(code),
                            name
                          )
                        ),
                        m('th[scope="row"].text-center', { colspan: warehouseList.length }, this.getText("LT00001269", "Warehouse")),

                      ),
                      m('tr.align-middle',
                        warehouseList.map(({ name, id }) =>
                          m('th[scope="row"]',
                            {
                              onclick: () => { _onSortClick(id) },
                            },
                            _getSortIcon(id),
                            name
                          )
                        ),
                      ),
                    ),
                    m('tbody.posm-user-wm-sticky-body',
                      (tableData.length == 0) &&
                      m('tr.align-middle',
                        m('td', { colspan: warehouseList.length + 4 }, this.getText("EM00000141", "No records found."))
                      ),
                      (tableData.length > 0) &&
                      tableData.map((row, index) => {
                        return m('tr.align-middle',
                          m('td.posm-user-wm-sticky-cell', row.UserId),
                          m('td.posm-user-wm-sticky-cell', row.UserName),
                          m('td.posm-user-wm-sticky-cell',
                            // { style: 'z-index:1' },
                            m('button.btn.btn-link.p-0', {
                              onclick: () => {
                                selectedMapping = structuredClone(row);
                                setTimeout(() => {
                                  document.getElementById('bottomElement').scrollIntoView({ block: 'center' })
                                }, 0)
                                // window.scrollTo(0, 10)
                              }
                            },
                              row.MovementTypeName
                            )
                          ),
                          warehouseList.map(({ name, id }) =>
                            m('td',
                              m(Checkbox, {
                                style: 'cursor: default',
                                checked: row[name + ':' + id],
                                readonly: true
                              })
                            ))
                        )
                      })
                    )
                  ])
                ),
                (tableData.length > 0) &&
                m(".px-3",
                  m(paginationComponent, {
                    currentPage: pagination.pageIndex,
                    pageSize: pagination.pageSize,
                    totalItems: pagination.totalItems,
                    data: tableData,
                    onPageChanged: _onPageChanged,
                    onPageSizeChanged: _onPageSizeChanged,
                  })
                )
              )
            )
          )
        ),
        // Table section - end
        m('#bottomElement'),

        // Update section
        selectedMapping &&
        m('.card.mb-3',
          m('.card-header.ps-3.d-flex.justify-content-between.gap-2', { style: "border: none" },
            m('h2.secondary-title.card-title', this.getText('LT00000498', 'Update') + ' (' + selectedMapping.MovementTypeName + ')'),
            m('.d-flex.justify-self-end.gap-2',
              m('button.btn.btn-primary', { onclick: _updateUserWarehouseMap },
                this.getText("LT00000022", "Save")
              ),
              m('button.btn.btn-white', { onclick: () => { selectedMapping = null; } },
                this.getText("LT00000021", "Close")
              )
            ),
          ),
          m('.ps-3.d-flex.gap-2', { style: "border: none" },
            m('.d-flex-column.justify-self-end.gap-2',
              m('div.d-flex',
                m('h3.card-title.pe-3', this.getText('LT00000049', 'User ID')),
                m('p', selectedMapping.UserId),
              ),
              m('div.d-flex',
                m('h3.card-title.pe-3', this.getText('LT00000050', 'User Name')),
                m('p', selectedMapping.UserName),
              ),
            ),
          ),
          m('.card-body',
            m('.row.g-2',
              renderUpdateField()
            ),
          )
        ),
        // Update section - end
        this.getBaseViews()
      ];
    }
  }
}